module.exports = {"id":"194015","name":"Julian Börner","rating":"73","photo":"./data/images/photos/4/194015.png","club":{"name":"Arminia Bielefeld","logo":"./data/images/clubs/ArminiaBielefeld.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianBorner0.json
// module id = 2235
// module chunks = 0